import React from 'react'
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
const { setEnvPrefix } = ssCommonUtils;

export default function PDFViewer(props) {
    const { filePath, options, space } = props;

    /** 
     * @param parameterOptions PDF parameters
     * @param parameterOptions.nameddest Open to a specified named destination in the PDF document
     * @param parameterOptions.page Open to a page in the document, takes precedence over nameddest
     * @param parameterOptions.toolbar Turns the toolbar off or on (0 or 1) 
     * @param parameterOptions.view Set the view to show some specified portion of the page, takes precedence over zoom (Fit, FitH, FitV)
     * @param parameterOptions.zoom Sets the zoom and scroll factors, using float or integer values
    */
    const parameterOptions = Object.assign({}, {
        nameddest: '',
        toolbar: 0,
        view: 'FitH',
    }, options)

    // Remove the view param because we want to use zoom
    if (parameterOptions.zoom) {
        delete parameterOptions.view;
    }

    let url = setEnvPrefix(filePath);

    for (const [key, value] of Object.entries(parameterOptions)) {
        if (url.endsWith('.pdf')) {
            url += `#${key}=${value}`
        } else {
            url += `&${key}=${value}`
        }
    }

    const getSpacingClass = () => {
        switch (space) {
            case 'lg': return 'ss-notice-container-lg';
            case 'xl': return 'ss-notice-container-xl';
            case 'home-page': return 'ss-notice-container-home-page';
            case 'popover': return 'ss-notice-container-popover';
            case 'home-page-FAQ': return 'ss-notice-container-home-FAQ';
            default: return 'ss-notice-container';
        }
    }

    return (
        <div className={getSpacingClass()} style={{ height: '100%' }}>
            <object type="application/pdf" data={url} height="100%" width="100%" />
        </div>
    )
}
